export default {
  getMode(state) {
    return state.mode;
  }
};
